import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { Booth } from './booth.model';
import { BoothPopupService } from './booth-popup.service';
import { BoothService } from './booth.service';
import { Salesunit, SalesunitService } from '../salesunit';
import { Contact, ContactService } from '../contact';
import { Contract, ContractService } from '../contract';

@Component({
    selector: 'jhi-booth-dialog',
    templateUrl: './booth-dialog.component.html'
})
export class BoothDialogComponent implements OnInit {

    booth: Booth;
    authorities: any[];
    isSaving: boolean;

    salesunits: Salesunit[];

    contacts: Contact[];

    contracts: Contract[];
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private boothService: BoothService,
        private salesunitService: SalesunitService,
        private contactService: ContactService,
        private contractService: ContractService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['booth', 'contractType']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.salesunitService.query().subscribe(
            (res: Response) => { this.salesunits = res.json(); }, (res: Response) => this.onError(res.json()));
        this.contactService.query().subscribe(
            (res: Response) => { this.contacts = res.json(); }, (res: Response) => this.onError(res.json()));
        this.contractService.query().subscribe(
            (res: Response) => { this.contracts = res.json(); }, (res: Response) => this.onError(res.json()));
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.booth.id !== undefined) {
            this.boothService.update(this.booth)
                .subscribe((res: Booth) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        } else {
            this.boothService.create(this.booth)
                .subscribe((res: Booth) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: Booth) {
        this.eventManager.broadcast({ name: 'boothListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        try {
            error.json();
        } catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    trackSalesunitById(index: number, item: Salesunit) {
        return item.id;
    }

    trackContactById(index: number, item: Contact) {
        return item.id;
    }

    trackContractById(index: number, item: Contract) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-booth-popup',
    template: ''
})
export class BoothPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private boothPopupService: BoothPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            if ( params['id'] ) {
                this.modalRef = this.boothPopupService
                    .open(BoothDialogComponent, params['id']);
            } else {
                this.modalRef = this.boothPopupService
                    .open(BoothDialogComponent);
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/booth/booth-dialog.component.ts